import { render, staticRenderFns } from "./Recomendaciones.vue?vue&type=template&id=2e0f00e2&"
import script from "./Recomendaciones.vue?vue&type=script&lang=js&"
export * from "./Recomendaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports